module.exports = __webpack_public_path__ + "static/template_options_year_photo_calendar-cb2accf8e7edd91ca568a334d19cbf5c.png";